import { FilterParams, filterkeySearch } from "../RVGridTypes";

/**
 * Returns the subset of filters whose keys match either the search key or any additional keys provided.
 *
 * @param filters - Filter collection sourced from the grid query params.
 * @param additionalFilters - Extra filter keys (besides the search key) that should be preserved.
 * @returns Filters matching the search key or one of the additional keys, preserving original order.
 */
export function getAdditionalFiltersFromQueryParams(
    filters: FilterParams[] | null | undefined,
    additionalFilters: string[]
): FilterParams[] {
    return filters?.filter((filter) => [filterkeySearch, ...additionalFilters].includes(filter.key)) ?? [];
}

/**
 * Pulls only the search filter entries out of the supplied filter list.
 *
 * @param filters - Filter collection sourced from the grid query params.
 * @returns All filters whose key equals the shared search key.
 */
export function getSearchFiltersFromQueryParams(filters: FilterParams[] | null | undefined): FilterParams[] {
    return filters?.filter((filter) => filter.key === filterkeySearch) ?? [];
}

/**
 * Removes search filters from the supplied filter list, leaving only non-search filters.
 *
 * @param filters - Filter collection sourced from the grid query params.
 * @returns Filters whose key differs from the shared search key.
 */
export function getNonSearchFiltersFromQueryParams(filters: FilterParams[] | null | undefined): FilterParams[] {
    return filters?.filter((filter) => filter.key !== filterkeySearch) ?? [];
}
